import { Droppable, DroppableProvided } from 'react-beautiful-dnd';
import { joinIds } from '../../helpers/utils';
import { SectionLayout, WidgetTypes } from '../../types';
import WidgetList from '../widgets/WidgetList';

interface Props {
  pageId: string;
  sectionId: string;
  widgets: WidgetTypes[];
  columnIndex: number;
  numberOfColumns: number;
  sectionLayout: SectionLayout;
  contentSpacing: number;
  isHovering?: boolean;
}

const ColumnEdit = ({
  widgets,
  pageId,
  sectionId,
  columnIndex,
  contentSpacing,
  numberOfColumns,
  sectionLayout,
  isHovering,
}: Props) => (
  // we need a unique Id for Droppable, so combine sectionId and columnIndex
  // into one string
  <Droppable droppableId={joinIds(sectionId, columnIndex.toString())}>
    {(droppableProvided: DroppableProvided) => (
      <WidgetList
        contentSpacing={contentSpacing}
        isHovering={isHovering}
        sectionLayout={sectionLayout}
        pageId={pageId}
        sectionId={sectionId}
        widgets={widgets}
        columnIndex={columnIndex}
        droppableProvided={droppableProvided}
        numberOfColumns={numberOfColumns}
      />
    )}
  </Droppable>
);

export default ColumnEdit;
